import { PromoStrip } from "../components/PromoStrip";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { ChiSono } from "../components/ChiSono";
import { Metodo } from "../components/Metodo";
import { Pacchetti } from "../components/Pacchetti";
import { FaqSection } from "../components/FaqSection";
import { ReviewsSection } from "../components/ReviewsSection";
import { Footer } from "../components/Footer";
import { CookieBanner } from "../components/CookieBanner";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#0d0718] text-[#ede8f5] min-h-screen antialiased overflow-x-hidden">
      <PromoStrip />
      <Navbar />
      <Hero />
      <ChiSono />
      <Metodo />
      <Pacchetti />
      <FaqSection />
      <ReviewsSection />
      <Footer />
      <CookieBanner />
    </div>
  );
}
